<template>
  <div>
    <loader :loader="sending" />
    <v-text-field
      v-model="searchTeleConsultation"
      append-icon="mdi-magnify"
      label="Buscar"
      single-line
      hide-details
      class="mx-5 mb-3"
    ></v-text-field>
    <v-data-table
      :headers="headersTeleConsulting"
      :items="listTelemedicineConsultations"
      :search="searchTeleConsultation"
      :items-per-page="10"
      :footer-props="{
        'items-per-page-text': 'Elementos por página',
        'items-per-page-all-text': 'Todo',
      }"
      no-results-text="Sin resultados coincidentes con la búsqueda"
      loading-text="Cargando..."
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
    >
      <template v-slot:[`item.diagnostic`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span color="red" dark v-bind="attrs" v-on="on">
              {{ item.diagnostic }}
            </span>
          </template>
          <span>{{ item.diagnostic1 }}</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.count`]="{ index }">
        {{ index + 1 }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        :disabled="item.idDiagnostic == null"
        @click="
          generatePDF(
            item.idMedicalPractice,
            item.startTime,
            item.idPatient,
            1
          )
        "
        v-bind="attrs"
        v-on="on"
      >
        <v-icon color="red" dark>mdi-file-pdf-box</v-icon>
      </v-btn>
    </template>
    <span>Informe médico</span>
  </v-tooltip>

  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        :disabled="item.idDiagnostic == null"
        @click="
          generatePDF(
            item.idMedicalPractice,
            item.startTime,
            item.idPatient,
            0
          )
        "
        v-bind="attrs"
        v-on="on"
      >
        <v-icon color="red" dark>mdi-file-pdf-box</v-icon>
      </v-btn>
    </template>
          <span>Entregable a paciente</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TelemedicineHistoryService from "@/app/services/TelemedicineHistoryService";
import Loader from "@/app/components/base/loader/Loader.vue";
export default {
  props: {
    listTelemedicineConsultations: Array,
  },
  components: {
    Loader,
  },
  data() {
    return {
      searchTeleConsultation: "",
      headersTeleConsulting: [
        { text: "#", value: "count" },
        { text: "Id Consulta", value: "idMedicalPractice" },
        { text: "Fecha de solicitud", value: "registrationDate" },
        { text: "Fecha de consulta", value: "consultationDate" },
        { text: "Doctor", value: "doctorName" },
        { text: "Diagnóstico", value: "diagnostic" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      sending: false,
    };
  },
  methods: {
    generatePDF(idMedicalPractice, time, idPatient, pdfType) {
  this.sending = true;
  const data = {
    idMedicalPractice,
    fileName: "TELEMEDICINA",
    idBranchOffice: this.$utilFront.getIdBranchOffice(),
    idPatient,
    type: pdfType, 
  };

  TelemedicineHistoryService.pdf(data)
    .then((res) => {
      if (res.status == 200 && res.data.type !== "application/json") {
        this.$utilFront.openPDF(res.data);
      } else {
        this.$utilFront.displayErrorPdf(res.data);
      }
    })
    .finally(() => {
      this.sending = false;
    });
},
  },
};
</script>

<style></style>